import React from 'react';

import { MenuItemProps } from '@mui/material';

import { Radio } from '~/components/Radio';

import { RadioOption } from './styled';

export const DropdownRadioOption = React.memo(function DropdownRadioOption<
  C extends React.ElementType
>(props: MenuItemProps<C, { component?: C }>) {
  const { children, selected, ...others } = props;

  return (
    <RadioOption selected={selected} {...others} >
      <Radio sx={{ py: '1px', px: '14px' }} checked={selected} />
      {children}
    </RadioOption>
  );
});
